
import * as React from 'react';
import { useState } from 'react';

import { Card, CardContent } from '@/components/ui/card';
import { cn } from '@/lib/utils';

import { CodeAutocomplete } from './cli/code.autocomplete';
import { CodeCli } from './cli/code.cli';
import { cliFeature } from './constants';
import { FeatureItem } from './shared/feature.item';
import { SectionHeader } from './shared/section.header';

export function SectionCli() {
  const [highlightedFeature, setHighlightedFeature] = useState<string | null>(
    null,
  );

  return (
    <section className="redesign-container py-12 md:py-24">
      <div className="mx-auto max-w-7xl">
        <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2">
          <div className="lg:pt-4 lg:pr-8">
            <div className="lg:max-w-lg">
              <SectionHeader
                subtitle="Type-Safety"
                title="Built for TypeScript"
                description="FlagSync's CLI generates TypeScript types from your feature flag config. Get autocompletion, compile-time safety, and confidence your code matches your flags."
              />
              <dl className="mt-10 max-w-xl space-y-8 text-base/7 lg:max-w-none">
                {cliFeature.features.map((feature, index) => (
                  <FeatureItem
                    key={index}
                    icon={feature.icon}
                    title={feature.name}
                    description={feature.description}
                    onMouseEnter={() => setHighlightedFeature(feature.key!)}
                    onMouseLeave={() => setHighlightedFeature(null)}
                  />
                ))}
              </dl>
            </div>
          </div>
          <div>
            <Card className="py-2 rounded-lg">
              <CardContent className="flex flex-col gap-2 px-2">
                <CodeCli highlightedFeature={highlightedFeature} />
                <CodeAutocomplete
                  className={cn('transition-all duration-300', {
                    'bg-halfmast-1100 ring-2 ring-primary':
                      highlightedFeature === 'usage',
                  })}
                />
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>
  );
}
